
import { useState } from "react";
const ChatInput = ({handleSendMessage, isActiveUserConnected,  sendFile}) => {
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !isActiveUserConnected || !sendFile) return;
    
    setIsUploading(true);
    
    // Convert file to Base64
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const fileData = {
          type: "file",
          file_name: file.name,
          file_data: reader.result, // Base64
        };
        
        // Use the sendFile function from useChat hook
        await sendFile(fileData);
        
        // Clear the file input
        e.target.value = '';
        
        // Fetch updated messages
    
      } catch (error) {
        console.error("Error sending file:", error);
      } finally {
        setIsUploading(false);
      }
    };
    
    reader.onerror = () => {
      console.error("Error reading file");
      setIsUploading(false);
    };
    
    reader.readAsDataURL(file);
  };

  return (
    <div className="p-4 border-t border-gray-100 bg-white rounded-br-[10px] ">
      <form className="flex items-center gap-2" onSubmit={handleSendMessage}>
        <div className="flex-1 relative">
          <input
            type="text"
            name="messageInput"
            placeholder={
              isActiveUserConnected
                ? "Type your message..."
                : "User is currently offline"
            }
            disabled={!isActiveUserConnected}
            className={`w-full px-5 py-3 text-gray-900 rounded-xl border transition-all duration-200 ${
              isActiveUserConnected
                ? "border-gray-300 bg-white focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 focus:outline-none hover:border-gray-400"
                : "border-gray-200 bg-gray-50/50 text-gray-500 cursor-not-allowed"
            }`}
          />
          
          {/* Attachment Button */}
          {isActiveUserConnected && (
            <>
              <label
                htmlFor="file-upload"
                className={`absolute right-3 top-1/2 -translate-y-1/2 p-1.5 transition-colors ${
                  isUploading 
                    ? "text-gray-400 cursor-not-allowed" 
                    : "text-gray-400 hover:text-gray-600 cursor-pointer"
                }`}
                title={isUploading ? "Uploading..." : "Add attachment"}
              >
                {isUploading ? (
                  <div className="w-5 h-5 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                  </svg>
                )}
              </label>
              <input
                id="file-upload"
                type="file"
                className="hidden"
                onChange={handleFileChange}
                disabled={isUploading || !isActiveUserConnected}
              />
            </>
          )}
        </div>
        
        <button
          className={`flex items-center justify-center px-5 py-3 rounded-xl font-medium transition-all duration-200 ${
            isActiveUserConnected
              ? "bg-[#0f6abf] text-white hover:bg-[#0a5ca8] active:scale-[0.98]"
              : "bg-gray-200 text-gray-400 cursor-not-allowed"
          }`}
          type="submit"
          disabled={!isActiveUserConnected || isUploading}
          title={isActiveUserConnected ? "Send message" : "User is offline"}
        >
          {isUploading ? (
            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
          )}
        </button>
      </form>
      
      {/* Uploading indicator */}
      {isUploading && (
        <div className="mt-2 px-1">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
            <p className="text-xs text-gray-500">Uploading file...</p>
          </div>
        </div>
      )}
      
      {/* Helper text when offline */}
      {!isActiveUserConnected && (
        <div className="flex items-center gap-2 mt-2 px-1">
          <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
          <p className="text-xs text-gray-500">Messages will be sent when user comes online</p>
        </div>
      )}
    </div>
  )
}

export default ChatInput